import React from 'react';
import { Checkbox, Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { MortgageProgramCodeType } from '@search/graphql-typings';
import { MORTGAGE_PROGRAMS } from '../../common/constants';

import './style.css';

const cn = classname.bind(null, 'MobileMortgagePrograms');

export const MobileMortgagePrograms = ({
    stateProgramCode,
    onChange,
}: {
    stateProgramCode: MortgageProgramCodeType;
    onChange: (value: string | number) => void;
}) => {
    const drawMortgageProgramItems = () => {
        return (
            <>
                {MORTGAGE_PROGRAMS.map((item, index) => (
                    <div
                        className={cn('item', { active: item.mortgageProgramCodes === stateProgramCode })}
                        key={index}
                        onClick={() => {
                            onChange(item.mortgageProgramCodes);
                        }}
                    >
                        <div className={cn('programInfo')}>
                            <div className={cn('checkbox')}>
                                <Checkbox
                                    color='primary'
                                    radio
                                    value={item.mortgageProgramCodes === stateProgramCode}
                                />
                            </div>
                            <Typography
                                className={cn('programName')}
                                variant='primary'
                                bold
                            >
                                {item.mobileName}
                            </Typography>
                            {item.label && (
                                <div className={cn('labelWrap')}>
                                    <Typography variant='small-alone' className={cn('label')}>
                                        {item.label[0]}
                                    </Typography>
                                </div>
                            )}
                        </div>
                        {item.mortgageProgramCodes === stateProgramCode && (
                            <div className={cn('programDisclaimer')}>
                                {item.infoDesk?.map((i, idx) => (
                                    <Typography
                                        key={idx}
                                        variant='small-alone'
                                        color='secondary'
                                    >
                                        {i}
                                    </Typography>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </>
        );
    };

    return (<div className={cn()}>
        <div className={cn('programsWrap')}>
            {drawMortgageProgramItems()}
        </div>
    </div>);
};
